import { Navigate } from 'react-router-dom';

/**
 * this component is called "switch" because sometimes we want to redirect
 * based on some condition
 */
export const HomeSwitch = () => {
  return <Navigate to="/home" />;
};
